import React, { useEffect, useState } from "react";
import { IconPatientJourney } from "../../../assets/icons/icon-patient-journey";
import { PhoneCall, PhoneMissed } from "lucide-react";
import CallHistory from "./call-history";
import { fetchCallLogs } from "../../../js/api/call-log";

const PatientScreen = () => {
  return (
    <div className="">
      <div className="text-center w-[100%] mb-5">
        <IconPatientJourney />
      </div>
      <p className="text-center w-[100%]">Coming soon</p>
    </div>
  );
};

export default PatientScreen